import { render } from "./InvestmentMemoForm.vue?vue&type=template&id=58e0005a&scoped=true"
import script from "./InvestmentMemoForm.vue?vue&type=script&lang=js"
export * from "./InvestmentMemoForm.vue?vue&type=script&lang=js"

import "./InvestmentMemoForm.vue?vue&type=style&index=0&id=58e0005a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e0005a"]])

export default __exports__